import React from "react";
import { Button, Group, Modal, Text } from "@mantine/core";
import SchedulingDrawer from "../components/AppointmentModal/SchedulingDrawer";
import type { BookingSession } from "./useBookingSession";
import type { CalendarEventType } from "../../../../types/calendar";

interface BookingPanelProps {
  booking: BookingSession;
  /** Loaded calendar events (the drawer's overlap warning). */
  calendarEvents?: CalendarEventType[];
}

/**
 * The booking push-panel (drawer + form) and its discard-changes confirm.
 * Any interruption of an edited draft (Cancel / close / Escape / clicking a
 * real event in a new booking) lands on the confirm; Discard closes the
 * session (and opens the clicked event's preview, if that raised it).
 */
const BookingPanel: React.FC<BookingPanelProps> = ({
  booking,
  calendarEvents,
}) => (
  <>
    <SchedulingDrawer
      opened={booking.panelOpen}
      onRequestClose={booking.requestClose}
      mode={booking.mode}
      sourceTransaction={booking.sourceTxn}
      onEditSuccess={booking.handleEditSuccess}
      day={booking.day}
      rows={booking.rows}
      onRowsChange={booking.handleRowsChange}
      clientUuid={booking.clientUuid}
      onClientChange={booking.handleClientChange}
      activeUid={booking.activeUid}
      onActiveChange={booking.handleActiveChange}
      onSuccess={booking.handleCreated}
      calendarEvents={calendarEvents}
    />

    <Modal
      opened={booking.panelOpen && booking.discardPromptOpen}
      onClose={booking.dismissDiscard}
      title="Discard changes?"
      centered
      size="sm"
      zIndex={400}
    >
      <Text size="sm" c="dimmed">
        Your unsaved appointment will be lost.
      </Text>
      <Group justify="flex-end" mt="lg">
        <Button variant="default" onClick={booking.dismissDiscard}>
          Keep editing
        </Button>
        <Button color="red" onClick={booking.discard}>
          Discard
        </Button>
      </Group>
    </Modal>
  </>
);

export default BookingPanel;
